import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../constants/documentTheme';

export const documentOverlayActionSx = {
  color: DOCUMENT.ivory,
  borderColor: 'rgba(255,255,255,0.5)',
  border: '1px solid rgba(255,255,255,0.5)',
  borderRadius: 0,
  textTransform: 'none',
  '&:hover': { borderColor: DOCUMENT.ivory, bgcolor: 'rgba(255,255,255,0.1)' },
};

const DocumentPageOverlay = ({
  open,
  onClose,
  title,
  testId = 'document-page-overlay',
  actions = null,
  variant = 'fullscreen',
  dialogZIndex,
  children,
}) => {
  const { t } = useTranslation();
  const compact = variant === 'compact';

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          onClose?.();
        }
      }}
      maxWidth={compact ? 'sm' : 'xl'}
      fullWidth
      sx={dialogZIndex ? { zIndex: dialogZIndex } : undefined}
      PaperProps={{
        'data-testid': testId,
        sx: compact
          ? {
              width: '100%',
              maxWidth: 520,
              maxHeight: 'min(90vh, 820px)',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              borderRadius: 1,
              bgcolor: DOCUMENT.canvas,
            }
          : {
              height: '95vh',
              maxHeight: '95vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              borderRadius: 0,
              bgcolor: DOCUMENT.canvas,
            },
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          zIndex: 10,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: DOCUMENT.oxblood,
          color: DOCUMENT.ivory,
          px: 3,
          py: 1.5,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, pr: 2 }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0 }}>
          {actions}
          <IconButton aria-label={t('common.close')} onClick={onClose} sx={{ color: DOCUMENT.ivory, zIndex: 2 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <DialogContent
        sx={{
          p: 0,
          pt: 0,
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'auto',
          '&.MuiDialogContent-root': { padding: 0 },
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPageOverlay;
